import { render, staticRenderFns } from "./Postbacks.vue?vue&type=template&id=9958d218&scoped=true&"
import script from "./Postbacks.js?vue&type=script&lang=js&"
export * from "./Postbacks.js?vue&type=script&lang=js&"
import style0 from "./Postbacks.scss?vue&type=style&index=0&id=9958d218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9958d218",
  null
  
)

export default component.exports